import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupInlineComponent } from '../popup-inline/popup-inline.component';


@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        PopupInlineComponent
    ],
    exports: [
        PopupInlineComponent
    ],
})
export class UXEssentialsModule { }
